import { BCDataGrid, BCTreeList } from '@bimser/components';
import { compareMatchWithCollection, isNullOrUndefined } from '@bimser/core';
import DataGrid2 from '../..';
import { calculateFormat } from '../../../../../../helper';
import {
	datePickerFormatter,
	dateTimePickerFormatter,
	timePickerFormatter
} from '../columnFormatters';

export function onEditorPreparing(
	this: DataGrid2,
	e:
		| BCDataGrid.Entities.DataGridTypes.EditorPreparingEvent
		| BCTreeList.Components.TreeListTypes.EditorPreparingEvent
) {
	const keyExpr = this.getUniqueDataField();

	if (keyExpr === e.dataField && e.row && !e.row.isNewRow) {
		e.editorOptions.disabled = true;
	}

	setEditorOptions(this, e);

	if (
		(e as any).command === 'select' &&
		this.selection.disabledValueColumnName &&
		this.selection.disabledValueMatchers.length
	) {
		const disabledValue = e.row?.data[this.selection.disabledValueColumnName];

		if (isNullOrUndefined(disabledValue)) {
			return;
		}

		const bcColumn = this.__getBCColumn(this.selection.disabledValueColumnName);

		if (
			compareMatchWithCollection({
				compareValue: disabledValue,
				value: e.value,
				dataType: bcColumn.dbType.type,
				editType: bcColumn.editType,
				format: bcColumn.format
			})
		) {
			e.editorOptions.disabled = true;
			e.editorOptions.onValueChanged = function (ev) {
				e.component.deselectRows([e.row.key]);
			};
		}
	}
}

const setEditorOptions = (
	dataGrid: DataGrid2,
	e:
		| BCDataGrid.Entities.DataGridTypes.EditorPreparingEvent
		| BCTreeList.Components.TreeListTypes.EditorPreparingEvent
) => {
	const bcColumn = dataGrid.__getBCColumn(e.dataField);

	if (!bcColumn) {
		return;
	}

	switch (bcColumn.editType) {
		case 'multiLanguageTextBox': {
			e.editorOptions.getDropdownContainer = dataGrid.__form.__getShadowRootContainer;
			break;
		}
		case 'timePicker': {
			e.editorOptions.showClearButton = true;
			e.editorOptions.format = timePickerFormatter.bind(bcColumn);
			e.editorOptions.calendarOptions = { visible: false };
			e.editorOptions.validationMessagePosition = 'right';
			break;
		}
		case 'datePicker': {
			e.editorOptions.showClearButton = true;
			e.editorOptions.format = datePickerFormatter.bind(bcColumn);
			e.editorOptions.validationMessagePosition = 'right';
			break;
		}
		case 'dateTimePicker': {
			e.editorOptions.showClearButton = true;
			e.editorOptions.format = dateTimePickerFormatter.bind(bcColumn);
			e.editorOptions.validationMessagePosition = 'right';
			break;
		}
		case 'numberBox': {
			e.editorOptions.showSpinButtons = true;
			e.editorOptions.showClearButton = true;
			e.editorOptions.format = calculateFormat(bcColumn);
			e.editorOptions.max = calculateMax(
				bcColumn.precision,
				(bcColumn.editControl as any).size
			);
			e.editorOptions.min = calculateMin(
				bcColumn.precision,
				(bcColumn.editControl as any).size
			);
			break;
		}
	}
};

const calculateMax = (precision?: number, size?: number) => {
	if (!size) {
		return;
	}

	let max = '9'.repeat(size);

	if (!precision) {
		return Number(max);
	}

	return Number(`${max.slice(0, max.length - precision)}.${max.slice(max.length - precision)}`);
};

const calculateMin = (precision?: number, size?: number) => {
	const max = calculateMax(precision, size);

	if (!max) {
		return;
	}

	return max * -1;
};
